import * as React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { makeStyles } from '@mui/styles';
import { Checkbox, FormControlLabel, FormHelperText, Typography } from '@mui/material';
import { getBatches} from 'services/batch';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const useStyles = makeStyles((theme) => ({
    error: {
        marginLeft: 16,
    },
    root: {
        margin: "8px 0",
        borderRadius: "6px",
        fontSize: 12,
        fontWeight: "normal",
        "& .MuiInputLabel-root": {
            fontSize: "12px !important",
            fontWeight: "normal !important",
        },
        "& .MuiFilledInput-root": {
            fontSize: 12,
            fontWeight: "normal",
            borderRadius: "6px",
            backgroundColor: "white",
            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.15)",
            '&>*': {
                padding: 10
            }
        },
        '& .MuiOutlinedInput-root': {
            backgroundColor: "#E4E3E8",
            borderRadius: "6px",
            fontSize: 12,
            fontWeight: "normal",
            '& fieldset': {
                borderRadius: "6px",
                borderColor: "transparent",
                fontWeight: "normal",
                fontStyle: "normal",
                fontFamily: "'Inter', sans-serif",
                fontSize: 12,
            },
            '&:hover fieldset': {
                borderColor: '#02569D',
                borderRadius: "6px",
                fontSize: 12,
                fontWeight: "normal",

            },
            '&.Mui-focused fieldset': {
                borderColor: '#02569D',
                borderRadius: "6px",
                fontSize: 12,
                fontWeight: "normal",
            },
        },
    },
}));

export default function BatchSelect({
    defaultValue, onChange = (batches) => { }, error = "", client
}) {
    const classes = useStyles();
    const [batches, setBatches] = React.useState([]);

    const handleBatchChange = (event, newValue) => {
        onChange(newValue);
    }

    React.useEffect(() => {
        (async () => {
            const { batches } = await getBatches({ client });
            setBatches(batches);
        })();
    }, [client]);
    return (
        <>
            <Autocomplete
                fullWidth
                multiple
                id="batches"
                size="small"
                options={batches}
                disableCloseOnSelect
                onChange={handleBatchChange}
                getOptionLabel={(option) => option.name}
                renderOption={(props, option, { selected }) => (
                    <Typography
                        {...props}
                        component="li"
                        sx={{ fontSize: 14, fontWeight: "normal", color: "inherit" }}
                    >
                        <Checkbox
                            icon={icon}
                            value={option.value}
                            checkedIcon={checkedIcon}
                            checked={selected}
                        />
                        {option.name}
                    </Typography>
                )}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Choose Batches"
                        className={classes.root}
                        error={!!error}
                    />
                )}
            />
            {!!error && <FormHelperText className={classes.error} error>
                {error}
            </FormHelperText>
            }
        </>
    );
}

export function BatchSingleSelect({ 
  defaultValue, onChange = (batch) => { }, error = "", client, forPathway = false, disabled=false
}) {
    const classes = useStyles();
    const [batches, setBatches] = React.useState([]);
    const [value, setValue] = React.useState(null);
    const handleBatchChange = (event, newValue) => {
        setValue(newValue);
        onChange(newValue);
    }
    React.useEffect(() => {
        if (!client) return;
        (async () => {
            const filters = { client };
            if (forPathway) filters['forPathway'] = true;
            const { batches } = await getBatches(filters);
            setBatches(batches);
        })();
    }, [client]);

    React.useEffect(() => {
        const batch = batches.find(c => c._id === defaultValue);

        if (batch) {
            setValue(batch);
            onChange(batch);
        }
    }, [batches, defaultValue]);

    return (
        <>
            <Autocomplete
                fullWidth
                size="small"
                options={batches}
                value={value}
                name='batch'
                onChange={handleBatchChange}
                disabled={disabled}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={`Choose a Batch`}
                        className={classes.root}
                        error={!!error}
                    />
                )}
                getOptionLabel={(user) => `${user.name}`}
                renderOption={(props, option) => (
                    <Typography
                        {...props}
                        component="li"
                        sx={{ fontSize: 14, fontWeight: "normal", color: "inherit" }}
                    >
                        {option.name}
                    </Typography>
                )}
            />
            {!!error && <FormHelperText className={classes.error} error>{error}</FormHelperText>}
        </>
    );
}
